// import { MeasurementLineStyle } from '@/__generated__/graphql';
import { MeasurementLinesStyle } from '@fabric-web/3d-viewer';

export const DEFAULT_MEASURMENT_LINES_STYLE: MeasurementLinesStyle = {
  color: 0xffffff,
  opacity: 1,
  lineWidth: 12,
  showMarkers: true,
  markerSize: 5,
  markerColor: 0xffffff,
  markerOpacity: 1,
  fixedScreenSize: true,
};
